
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        try {
            const { data } = await client.get("/auth/me");
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // If returning from OAuth callback, skip - AuthCallback handles it
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        fetchMe();
    }, [fetchMe]);

    const login = async (email, password) => {
        const { data } = await client.post("/auth/login", { email, password });
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password) => {
        const { data } = await client.post("/auth/register", { name, email, password });
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await client.post("/auth/logout");
        } catch { /* logout failure is non-blocking */ }
        setUser(null);
    };

    const refresh = fetchMe;

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
